var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsSplat2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 738,
    height: 1504,
    viewBox: "0 0 738 1504",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_889_3396)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M788.342 466.464C857.752 477.932 930.017 461.754 993.839 490.401C1063.09 521.483 1124.7 569.67 1161.65 634.023C1200.13 701.051 1205.34 778.919 1203.44 855.471C1201.34 940.34 1227.28 1058.47 1150.13 1099.66C1062.19 1146.61 958.103 1010.87 861.57 1037.99C765.291 1065.05 751.159 1262.06 653.724 1239.15C558.699 1216.81 631.493 1051.77 579.946 971.786C541.186 911.64 425.814 918.761 403.749 851.251C382.266 785.519 459.262 728.314 478.697 661.995C502.989 579.102 457.027 461.333 531.863 414.076C606.44 366.983 700.424 451.939 788.342 466.464Z",
    fill: "url(#paint0_linear_889_3396)",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_889_3396",
    x: 0,
    y: 0,
    width: 1606,
    height: 1641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_889_3396"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_889_3396",
    x1: 336.244,
    y1: 1329.78,
    x2: 1244.52,
    y2: 400.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0398851,
    stopColor: "#31D054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F64E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsSplat2);
export default __webpack_public_path__ + "static/media/about_us_splat_2.c8492bccf26abb2cb4165b7e8d582040.svg";
export { ForwardRef as ReactComponent };